/* dynamic content tab child name */
export const DYNAMIC_CONTENT_TAB_NAME = 'fs.res.common.dynamicContent.tab.dynamicFields';
/* dynamic field container anchor */
export const DYNAMIC_FIELD_ANCHOR = 'dynamicFieldContainer';
/* dynamic field container anchor */
export const DYNAMIC_FIELDSET_ANCHOR = 'dynamicFieldSetContainer';
